module.exports = __webpack_public_path__ + "static/media/img03.03fa898a.webp";